import type { AnyAction } from 'redux';

import type { PaleState } from '@/interfaces';
import defaultState from './defaultState';

import { resultReducer } from './resultActions';
import { filterReducer } from './filterActions';
import { hotelResultReducer } from './hotelResultActions';
import { hotelReducer } from './hotelActions';
import { appStateReducer } from './appStateActions';

export const reducer = (state: PaleState = defaultState, action: AnyAction) => ({
    ...state,
    filters: filterReducer(state.filters, action),
    results: resultReducer(state.results, action),
    hotelResults: hotelResultReducer(state.hotelResults, action),
    hotel: hotelReducer(state.hotel, action),
    appState: appStateReducer(state.appState, action),
});
